import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RxjsDirective } from '@app/shared/rxjs.directive';
import { finalize, Observable } from 'rxjs';

@Component({
  selector: 'app-async-mat-icon-button',
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
  ],
  templateUrl: './async-mat-icon-button.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./async-mat-icon-button.scss'],
})
export class AsyncMatIconButton<T> extends RxjsDirective {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) action!: Observable<T>;
  @Input() disabled = false;
  @Input() ariaLabel = 'Action';
  @Input() title = 'Action';
  @Input() progress: 'bar' | 'spinner' = 'spinner';

  @Output() actionResult = new EventEmitter<T>();

  protected isPending = false;

  protected handleClick(): void {
    if (this.disabled || this.isPending) {
      return;
    }

    this.isPending = true;
    this.cdr.detectChanges();

    if (!this.action) {
      this.clearPending();
      return;
    }

    this.register(
      this.action.pipe(finalize(() => this.clearPending())).subscribe((value) => {
        this.actionResult.emit(value);
      }),
    );
  }

  private clearPending(): void {
    this.isPending = false;
    this.cdr.detectChanges();
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
